import { Injectable } from '@angular/core';

import { ScreenWidth } from '../enums/screen-width.enum';

@Injectable({
    providedIn: 'root'
})
export class ScreenSizeService {
    public isScreenWidthMedium(): boolean {
        return window.innerWidth <= ScreenWidth.Medium;
    }
}
